import api from './../../service/apiService'
import { CheckLQ, Pages, FutureNotification, Service, CartActions, DOFlow, MTNValidation, Save, BannerTypes, PAGEACTIVITY, HOAFlow } from './../../constants/actionType'
import { apiUrl } from './../../constants/apiUrl'
import { redirectTo } from './redirection'
import { errorAction } from './error'
import {
    logKafka,
    detailsInfo,
    logOtherInfo,
    updateisLogRequired,
    getPgLoggerObj,
    catchJSException,
} from './../../service/logService';
import { loaderActive } from './loder'
import { updateSCTags, updateSCcustomEvent, tempSCData } from './../../service/dtmTag'
//import * as resp from './../containers/addressQualification/sampleMTNValidation'
import { doCreditAssessment } from './checkout';
import { getCartHeader, getCartData } from './../../util/cartUtility'
import { InHomeUtils } from './../../util/inhomeUtils';
import OrderingBanners from "../../containers/banner/OrderingBanners.json";
import { fetchHoaDefaults } from './buildProduct'
let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
let isIONTAddr= false;

const defaultUnit = [{
    addressId: "N",
    baseAddressId: "N",
    unit: "I don't live in a unit"
},
{
    addressId: "",
    baseAddressId: "",
    unit: "I can't find my unit"
}];

const TOTAL_UNITS_CUTOFF = 10;

const defaultStreet = {
    value: {
        addressID: "",
        baseAddID: "",
        elkStreet: "",
        street: "I can't find my address"
    },
    displayValue: "I can't find my address"
};

export const setCookie = (cookies, data, props) => {
    try {
        let domain = "localhost";
        if (document.location.href.indexOf("localhost") > -1) {
            //domain="verizon.com";
            cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
            cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        }
        props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
        props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
    }
    catch (ex) {
        catchJSException('loopQual', props.appState.visitId, 'setCookie', ex);
    }
}

export const setLoggerObj = (props, loggerObj) => {
    if (InHomeUtils.isNotNull(loggerObj)) {
        props.dispatch({ type: "UPDATE_LOGGEROBJ", value: { enableUserAction: loggerObj.enableUserAction, enableApiTiming: loggerObj.enableApiTiming, enablePageLoad: loggerObj.enablePageLoad } });
    }
}

export const setVendorCookie = (cookies, data, props, GlobalSessionName) => {
    try {

        let domain = "localhost";
        if (document.location.href.indexOf("localhost") === -1) {
            domain = "verizon.com";
        }
        cookies.set('visit_id', data.visit_id, { path: '/', 'domain': domain });
        cookies.set('visitor_id', data.visitor_id, { path: '/', 'domain': domain });
        cookies.set(GlobalSessionName, data.visitor_id, { path: '/', 'domain': domain });
        props.dispatch({ type: "UPDATE_VISITID", value: { visitId: data.visit_id, visitorId: data.visitor_id } });
        props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
    }
    catch (ex) {
        catchJSException('loopQual', props.appState.visitId, 'setVendorCookie', ex);
    }
}

export const updateState = (selectedState, dispatch) => {
    dispatch({ type: CheckLQ.onZipcodeSelected, value: selectedState });
};

export const updateStateLocus = (selectedState, dispatch, showLQBtn) => {
    dispatch({ type: CheckLQ.onZipcodeSelected, value: selectedState });
    dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: selectedState, isdisplayUnit: showLQBtn } });
};

export const newService = (status, dispatch) => {
    dispatch({ type: CheckLQ.newService, value: status })
};

export const lqRevisit = (status, dispatch) => {
    dispatch({ type: CheckLQ.lqRevisit, value: status })
};

export const updateInitLoadSec = (sec, dispatch) => {
    dispatch({ type: CheckLQ.updateInitLoad, value: sec })
};

export const updateDOFlowDetails = (doidvalue, dispatch) => {
    dispatch({ type: DOFlow.onDoFlowCreation, value: doidvalue })
};

export const emptyBuildProductState = (dispatch) => {
    dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
}

export const emptyCartState = (dispatch) => {
    dispatch({ type: 'EMPTYCARTSTATE', value: "" });
}

export const emptyDOFlowState = (dispatch) => {
    dispatch({ type: DOFlow.onEmptyDoFlowStatus, value: "" });
}

export const chatEnable = (chatEnable, dispatch) => {
    dispatch({ type: CheckLQ.chatEnable, value: chatEnable })
};

export const isOnlineCCFlow = (isOnlineCCFlow, dispatch) => {
    dispatch({ type: CheckLQ.isOnlineCCFlow, value: isOnlineCCFlow })
};

export const isFCPflow = (isFCPflow, dispatch) => {
    dispatch({ type: CheckLQ.isFCPflow, value: isFCPflow })
};

export const isoneLQFlow = (isoneLQFlow, dispatch) => {
    dispatch({ type: CheckLQ.isoneLQFlow, value: isoneLQFlow })
};

export const isoneLQFlowDev = (isoneLQFlowDev, dispatch) => {
    dispatch({ type: CheckLQ.isoneLQFlowDev, value: isoneLQFlowDev })
};

export const isMultiadr = (isMultiadr, dispatch) => {
    dispatch({ type: CheckLQ.isMultiadr, value: isMultiadr })
};

export const skipCaptcha = (skipCaptcha, dispatch) => {
    dispatch({ type: CheckLQ.skipCaptcha, value: skipCaptcha })
};

export const OtpBypassFlow = (isOtpBypassFlow, dispatch) => {
    dispatch({ type: "OTP_BYPASSFLOW", value: isOtpBypassFlow })
};

export const updateVendorDetails = (value, dispatch) => {
    dispatch({ type: 'VENDOR_DETAILS', value: value })
};

export const updateJMPOfferFlowStatus = (value, dispatch) => {
    dispatch({ type: 'IS_ENABLE_JMP_OFFER_FLOW', value: value })
}

export const updatePgLoggerObjConfig = (obj) => {
    getPgLoggerObj(obj);
}

export const updateTargetOrdering = (value, dispatch) => {
    dispatch({ type: 'IS_TARGETORDERING', value: value })
};

export const updateToken = (status, dispatch) => {
    dispatch({ type: CheckLQ.updateToken, value: status })
};

export const updateCouponLQPage = (dispatch, val) => {
    dispatch({ type: CheckLQ.updateCouponLQPage, value: val })
}

export const validateToken = (tokenValue, dispatch, visitId) => {
    try {
        let url = apiUrl().validateCouponToken;
        let jsonstr = JSON.stringify({ customertoken: tokenValue });
        api(url, 'POST', jsonstr).then(response => {
            //response={"meta":{"code":200.01,"description":"AffinityToken Completed successfully .","timestamp":"Fri May 10 07:08:14 UTC 2019"},"data":{"result":{"status":"InValid","msg":"User Token is already expired"},"affinityCategoryDesc":"Employee Ultimate Offer"}}
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (response.data.result.status === "InValid" && response.data.result.msg.indexOf("expired") > -1) {
                    redirectTo(Pages.conflictMessage, dispatch);
                }
                else {
                    dispatch({
                        type: CheckLQ.updateCouponFlowType,
                        value: response.data.result.status === "Valid" ? response.data.flowType : null
                    });
                }

            }

            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:validateToken,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'validateToken', ex);
    }
};

export const existingService = (dispatch, visitId, holdService, roomate) => {
    try {
        let jsonstr = JSON.stringify({ holdforworkingservice: holdService, roomatescenario: roomate });
        let url = apiUrl().getExistingService;
        api(url, 'POST', jsonstr).then(response => {
            if (InHomeUtils.isNotNull(response)) {

                dispatch({
                    type: 'EXISTING_SERVICE',
                    value: response
                });
            }
        })
            .catch(error => {
                errorAction("ERROR", "LoopQual", error.message, "applogs", visitId, dispatch, false, "");
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'existingService', ex);
    }
};

const sortUnits = (a, b) => {
    if (a.displayValue.length < b.displayValue.length) {
        return -1;
    }
    if (a.displayValue.length > b.displayValue.length) {
        return 1;
    }
    if ((a.displayValue < b.displayValue)) {
        return -1;
    }
    if (a.displayValue > b.displayValue) {
        return 1;
    }
};

const sortString = (a, b) => {
    const displayValueA = a.displayValue.toUpperCase(); // ignore upper and lowercase
    const displayValueB = b.displayValue.toUpperCase(); // ignore upper and lowercase

    return (displayValueA < displayValueB) ? -1 : ((displayValueA > displayValueB) ? 1 : 0);
};

export const updateStreetAddr = (streetAddr, lqState, visitId, dispatch) => {
    try {
        let isdisplayUnit = false; let checkUnitUrl = '';
        if (streetAddr != null) {
            updateSCTags("street address validation");
            updateSCTags("street address select");
            if (lqState.isoneLQFlow)
                checkUnitUrl = apiUrl().getUnit + "?baseAddressId=" + streetAddr.ntasAddrID;
            else
                checkUnitUrl = apiUrl().getUnit + "?baseAddressId=" + streetAddr.addressID;

            api(checkUnitUrl, 'GET', '', '', true).then(response => {
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                    if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) &&
                        response.data.unitDetails.length > 0) {
                        isdisplayUnit = true;
                        if (response.data.unitDetails.length > TOTAL_UNITS_CUTOFF) {
                            updateSCTags("units more than 10");
                            //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'updateStreetAddr', PAGEACTIVITY.MSG.unitCount + " - " + response.data.unitDetails.length, PAGEACTIVITY.UA));
                        }
                        else {
                            updateSCTags("units less than 10");
                        }

                        let unitsList = [];
                        let totalUnits = Number(response.data.total);
                        if (totalUnits <= TOTAL_UNITS_CUTOFF) {
                            defaultUnit.map(obj => response.data.unitDetails.push(obj));

                            unitsList = response.data.unitDetails.map(unitDetailsObj => {
                                return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
                            });
                            //sort units
                            unitsList.sort(sortUnits);
                        }
                        dispatch({
                            type: 'LQ_ON_UNIT_CHECK',
                            value: unitsList
                        });
                        dispatch({
                            type: 'LQ_DISABLE_UNIT_TYPEAHEAD',
                            value: (unitsList.length > 0) ? true : false
                        });

                    }
                    else {
                        //logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'updateStreetAddr', PAGEACTIVITY.MSG.NoUnit, PAGEACTIVITY.UA));
                    }
                }
                // updateSelectedStreetAddr(dispatch,{streetAddr:streetAddr,isdisplayUnit:isdisplayUnit});
                dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: streetAddr, isdisplayUnit: isdisplayUnit } });
            })
                .catch(error => {
                    let errorMsg = `MethodName:updateStreetAddr,errorMessage:${error.message}`;
                    logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                })


        }
        else {
            // updateSelectedStreetAddr(dispatch,{streetAddr:streetAddr,isdisplayUnit:isdisplayUnit});

            dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: null, isdisplayUnit: isdisplayUnit } });
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'updateStreetAddr', ex);
    }
};

export const updateUnit = (unit, dispatch) => {
    let selectedUnit = unit;
    dispatch({ type: CheckLQ.onUnitSelected, value: selectedUnit });
};

export const hideLQButton = (value, dispatch) => {
    dispatch({ type: CheckLQ.showLQonAdrEntry, value: value });
};

export const getZipcode = (zipCode, visitId, dispatch) => {
    try {
        let zipChangeReducer = {
            type: CheckLQ.onZipCodeChange,
            value: []
        };
        let zipSelectedReducer = {
            type: CheckLQ.onZipcodeSelected,
            value: null
        };
        const zipLoader = {
            type: CheckLQ.onShowZipLoader,
            value: !!(zipCode.length === 5)
        }
        dispatch(zipLoader);

        if (zipCode.length < 5) {
            dispatch({ type: CheckLQ.showLQonAdrEntry, value: false });
            dispatch(zipSelectedReducer);
            dispatch(zipChangeReducer);
        }

        let getZipUrl = apiUrl().getZipcode + "?zipcityterm=" + zipCode;
        api(getZipUrl, 'GET', '', '', true).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                InHomeUtils.isNotNull(response.zips) && response.zips.length) {
                if (!zipCode.length) {
                    dispatch(zipSelectedReducer);
                    dispatch(zipChangeReducer);
                } else if (zipCode.length === 5) {
                    zipSelectedReducer.value = response.zips[0];
                    updateSCTags("zip code validation");
                    dispatch(zipChangeReducer);
                    dispatch(zipSelectedReducer);
                } else {
                    let zipsList = response.zips.map(zipDetailsObj => {
                        return { value: zipDetailsObj, displayValue: zipDetailsObj.zip };
                    });
                    zipsList.sort(sortUnits);
                    dispatch({
                        type: 'SET_ZIP_CODES',
                        value: zipsList
                    });
                }
            } else {
                if (zipCode.length === 5) {
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getZipcode', PAGEACTIVITY.MSG.ZipNotFound, PAGEACTIVITY.UA));
                    tempSCData.detailPageName = "zip code oof"
                    updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                    dispatch({ type: 'ZIP_NOT_FOUND', value: null });
                }
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getZipCode,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'updateStreetAddr', ex);
    }

};

export const updateSigninBtnStatus = (dispatch, val) => {
    dispatch({ type: CheckLQ.updateSigninBtnStatus, value: val });
}

export const bypassLqAddressInput = (queryStringObj, lqState, visitId, dispatch) => {
    //zip
    try {
        let selectedZipObj = {
            altCity: queryStringObj.city,
            city: queryStringObj.city,
            state: queryStringObj.state,
            zip: queryStringObj.zip
        };
        let zipSelectedReducer = {
            type: CheckLQ.onZipcodeSelected,
            value: selectedZipObj
        };
        dispatch(zipSelectedReducer);

        //getStreetAddr
        let zip = queryStringObj.zip;
        let streetAddr = queryStringObj.addressline1;
        const street = streetAddr.replace(/[-_\/\\^$*+?,.()|[\]{}]/g, '');
        let getStreetUrl = apiUrl().getStreetAddr + "?zip=" + zip + "&streetterm=" + street.trim();
        getStreetUrl = encodeURI(getStreetUrl);
        api(getStreetUrl, 'GET', '', '', true).then(response => {
            if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) &&
                InHomeUtils.isNotNull(response.addressesbau) && response.addressesbau.length > 0) {

                let arrAddress = response.addressesbau.map(streetDetailsObj => {
                    return { value: streetDetailsObj, displayValue: streetDetailsObj.street.toLowerCase() };
                });
                arrAddress.sort(sortString);
                arrAddress.push(defaultStreet);
                const addReducers = {
                    type: 'LQ_ON_STREETADDR_CHANGE',
                    value: arrAddress
                };
                dispatch(addReducers);
                //added
                let selectedAdr = arrAddress[0].value;
                dispatch({
                    type: CheckLQ.onStreetAddrSelected,
                    value: { streetAddr: selectedAdr, isdisplayUnit: false }
                });

                //unit
                if (queryStringObj.addressline2) {
                    let unit = encodeURI(queryStringObj.addressline2);
                    let getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + selectedAdr.addressID + "&unitterm=" + unit;
                    api(getUnitUrl, 'GET', '').then(response => {
                        if ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                            InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) && response.data.unitDetails)) {
                            let unitsList;
                            if (unit === '' && response.data.total > TOTAL_UNITS_CUTOFF) {
                                unitsList = [];
                            } else if (InHomeUtils.isNotNull(response.data.unitDetails)) {
                                defaultUnit.map(obj => response.data.unitDetails.push(obj));
                                unitsList = response.data.unitDetails.map(unitDetailsObj => {
                                    return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
                                });
                                //sort units
                                unitsList.sort(sortUnits);
                            }
                            dispatch({ type: 'LQ_ON_UNIT_CHANGE', value: unitsList });
                            //added update unit
                            if (InHomeUtils.isNotNull(response.data.unitDetails)) {
                                dispatch({ type: CheckLQ.onUnitSelected, value: response.data.unitDetails[0] });
                            }
                        } else {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            errorAction("LBO", "CheckLQ", "", "applogs", visitId, dispatch, true, "GBBERR");
                        }
                    })
                        .catch(error => {
                            let errorMsg = `MethodName:bypassLqAddressInput-getUnit,errorMessage:${error.message}`;
                            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                        });
                }
            } else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                let errorMsg = `MethodName:bypassLqAddressInput,errorMessage:GBBERR`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);

                errorAction("LBO", "loopQual", "", "applogs", visitId, dispatch, true, "GBBERR");
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:bypassLqAddressInput-getStreetAdr,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'bypassLqAddressInput', ex);
    }

};

export const updateSelectedStreetAddr = (dispatch, valueToDispatch) => {

    dispatch({ type: CheckLQ.onStreetAddrSelected, value: valueToDispatch });
}

export const updateCaptcha = (dispatch, valueToDispatch) => {

    dispatch({ type: CheckLQ.captchaChanged, value: valueToDispatch });
}

export const getStreetAddr = (streetAddr, lqState, visitId, dispatch) => {
    try {
        let errMsg = ""; let status = "";
        let getStreetUrl = ''; let arrAddress = [];
        if (streetAddr || streetAddr === '0') {
            const street = streetAddr.replace(/[-_\/\\^$*+?,.()|[\]{}]/g, '');
            const showLQBtn = !!(street.length > 5);
            if (lqState.isMultiadr) {
                (lqState.showLQBtnAdrEntry !== showLQBtn) && dispatch({ type: CheckLQ.showLQonAdrEntry, value: showLQBtn });
                dispatch({ type: CheckLQ.adrEntered, value: street.trim() });
            }
            if (lqState.isoneLQFlowDev)
                getStreetUrl = "https://api-qa.ebiz.verizon.com/gwyv-locus-es-address-lookup/addresses/street?streetterm=" + street.trim();
            else if (lqState.isoneLQFlow)
                getStreetUrl = apiUrl().getStreetAddrLocus + street.trim();
            else
                getStreetUrl = apiUrl().getStreetAddr + "?zip=" + lqState.selectedState.zip + "&streetterm=" + street.trim();

            getStreetUrl = encodeURI(getStreetUrl);
            api(getStreetUrl, 'GET', '', '', true).then(response => {
                if (InHomeUtils.isNull(response)) {
                    errMsg = "ResponseNull";
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                    errMsg = response.message;
                    if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                        status = response.response.status;
                }
                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200') &&
                    (InHomeUtils.isNotNull(response.addressesbau) && response.addressesbau.length > 0) ||
                    (lqState.isoneLQFlow && InHomeUtils.isNotNull(response.addresses) && response.addresses.length > 0)) {
                    // response.addressesbau.push(defaultStreet);
                    if (lqState.isoneLQFlow) {
                        arrAddress = response.addresses.map(streetDetailsObj => {
                            return { value: streetDetailsObj, displayValue: streetDetailsObj.disprawstr.toLowerCase() };
                        });
                    }
                    else {
                        arrAddress = response.addressesbau.map(streetDetailsObj => {
                            return { value: streetDetailsObj, displayValue: streetDetailsObj.street.toLowerCase() };
                        });
                    }
                    arrAddress.sort(sortString);
                    arrAddress.push(defaultStreet);
                    const addReducers = {
                        type: 'LQ_ON_STREETADDR_CHANGE',
                        value: arrAddress
                    };
                    dispatch(addReducers);
                }
                else {
                    if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.StreetNotFound, PAGEACTIVITY.UA));
                    }
                    else if (status !== "" || errMsg !== "") {
                        // logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getStreetAddr', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + status, PAGEACTIVITY.UA));         
                    }
                    dispatch({
                        type: 'LQ_ON_STREETADDR_CHANGE',
                        value: []
                    })
                }
            })
                .catch(error => {
                    let errorMsg = `MethodName:getStreetAddr,errorMessage:${error.message}`;
                    logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                });
        }
        else {
            dispatch({
                type: 'LQ_ON_STREETADDR_CHANGE',
                value: []
            })
            dispatch({ type: CheckLQ.showLQonAdrEntry, value: false });
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getStreetAddr', ex);
    }
};

export const getUnit = (unit, lqState, visitId, dispatch) => {
    try {
        let getUnitUrl = '';
        if (lqState.isoneLQFlow)
            getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + lqState.selectedAdr.ntasAddrID + "&unitterm=" + unit;
        else
            getUnitUrl = apiUrl().getUnit + "?baseAddressId=" + lqState.selectedAdr.addressID + "&unitterm=" + unit;

        api(getUnitUrl, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.unitDetails) &&
                    response.data.unitDetails.length > 0) {
                    let unitsList;

                    if (unit === '' && response.data.total > TOTAL_UNITS_CUTOFF) {
                        unitsList = [];
                    } else {
                        defaultUnit.map(obj => response.data.unitDetails.push(obj));
                        unitsList = response.data.unitDetails.map(unitDetailsObj => {
                            return { value: unitDetailsObj, displayValue: unitDetailsObj.unit.toLowerCase() };
                        });
                        //sort units
                        unitsList.sort(sortUnits);
                    }
                    dispatch({
                        type: 'LQ_ON_UNIT_CHANGE',
                        value: unitsList
                    });
                }
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:getUnit,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getUnit', ex);
    }
};

export const resetAddressSuggestion = (dispatch) => {
    dispatch({ type: CheckLQ.suggestedAddress, value: [] });

}

export const checkAddr = (lqState, dispatch, visitId, email, mtn, isLqRetry = false) => {
    try {
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.InsideCheckAddr, PAGEACTIVITY.UA));
        let addrID = (lqState.selectedUnit
            && lqState.selectedUnit.addressId
            && lqState.selectedUnit.addressId !== "N") ? lqState.selectedUnit.addressId :
            (lqState.selectedAdr
                && lqState.selectedAdr.addressID
                && lqState.selectedAdr.addressID !== "N") ? lqState.selectedAdr.addressID : "0";
        let mtnValue = (mtn && mtn !== "") ? '&mtn=' + mtn : "";
        let emailValue = (email && email !== "") ? '&email=' + email : "";
        let isRememberMe = lqState.isRememberMeChecked ? "Y" : "N";
        let state = lqState?.selectedState && lqState?.selectedState?.state ? lqState?.selectedState?.state : "0";
        let zip = lqState?.selectedState && lqState?.selectedState?.zip ? lqState?.selectedState?.zip : "0";
        let city = lqState?.selectedState && lqState?.selectedState?.city ? lqState?.selectedState?.city : "";
        let errorMsg = ''; let status = '';

        if (addrID === "0" && lqState.isoneLQFlow) {
            addrID = lqState?.selectedState && lqState?.selectedState?.ntasAddrID ? lqState?.selectedState?.ntasAddrID : "0";
        }

        let doCheckLQUrl = apiUrl().checkAddr + parseInt(addrID) + "&state=" + state + '&zip=' + zip + mtnValue + emailValue + '&isRememberMe=' + isRememberMe;
        if(window.location && window.location.search){
            if(window.location.search.includes("acpFlow")){
                doCheckLQUrl = doCheckLQUrl + "&acpFlow=Y"
            }
            else if(window.location.search.includes("acpTestFlow")){
                doCheckLQUrl = doCheckLQUrl + "&acpTestFlow=Y"
            }
            else if(window.location.search.includes("vzfwd")){
                doCheckLQUrl = doCheckLQUrl + "&vzfwd=Y"
            }
            else if(window.location.search.includes("vfTestFlow")){
                doCheckLQUrl = doCheckLQUrl + "&vfTestFlow=Y"
            }
        }
        if (InHomeUtils.isNotNull(lqState.couponFlowType)) {
            doCheckLQUrl = doCheckLQUrl + "&isCareFlow=Y";
        }
        if (lqState.isFCPflow) {
            doCheckLQUrl = doCheckLQUrl + "&fcp=Y";
        }
        if (lqState.isoneLQFlow) {
            doCheckLQUrl = doCheckLQUrl + "&oneLQ=Y";
            let city1 = lqState.selectedAdr && lqState.selectedAdr.muni ? lqState.selectedAdr.muni : "";
            doCheckLQUrl = doCheckLQUrl + "&city=" + encodeURI(city1);
        }

        if (!(parseInt(addrID))) {
            let adr1 = "";
            adr1 = lqState.selectedAdr && lqState.selectedAdr.dispstr ? lqState.selectedAdr.dispstr : "";
            if (adr1 === "")
                adr1 = lqState.adrEntered ? lqState.adrEntered : "";
            if (!lqState.isoneLQFlow) {
                if (adr1 !== "" && city !== "" && state !== "")
                    adr1 = adr1 + "," + city + "," + state;
                if (adr1 === "")
                    adr1 = lqState.selectedAdr && lqState.selectedAdr.street ? lqState.selectedAdr.street : "";
            }
            if (adr1 !== "")
                doCheckLQUrl = doCheckLQUrl + "&addressLine1=" + encodeURI(adr1);
        }

        if (mtnValue !== '')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.mtnEntered, PAGEACTIVITY.UA));
        if (emailValue !== '')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.emailEntered, PAGEACTIVITY.UA));
        if (isRememberMe !== '' && isRememberMe === 'N')
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.RememberMe + '-N', PAGEACTIVITY.UA));

        let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;

        let NonFDVFlow = false;
        let qualResponse = null;
        api(doCheckLQUrl, 'GET', '').then(response => {
            if (!response) {
                logOtherInfo(detailsInfo('loopQual', visitId, 'checkAddr_1', "LQ Response is empty or null"));
                errorMsg = "LQResponseNull";
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                errorMsg = response.message;
                if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                    status = response.response.status;
            }
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.fiveG) && response.data.fiveG) {
                tempSCData.detailPageName = "lq address verification - 5G eligible - Redirecting to Wireless";
                tempSCData.events = "event5,event8,event88"
                updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                console.log("FiveG Success");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, '5G', PAGEACTIVITY.MSG.FIVEG, PAGEACTIVITY.UA));
                let addressString = response.data.encryptedAddressFor5G ? response.data.encryptedAddressFor5G : "";
                window.location.href = apiUrl().Wireless5Gurl
                //redirectTo(apiUrl().Wireless5Gurl, dispatch);
                return;
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.hoaFlag) && response.data.hoaFlag === "Y") {
                dispatch({ type: HOAFlow.onHoaFlowCreation, value: hoaValue });
                lqState.hoaFlowDetails = { isHoaFlow: true };
            }
            else if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) &&
                InHomeUtils.getIndexOf(response.meta.code, '200')) {
                if (response.data.parsedAddress && response.data.parsedAddress.length > 1) {
                    loaderActive({ isLoaderActive: false }, dispatch);
                    console.log('CheckLQ.suggestedAddress', CheckLQ.suggestedAddress || 'not found');
                    const dispatchValue = { type: CheckLQ.suggestedAddress, value: response.data.parsedAddress };
                    dispatch(dispatchValue);
                }
                else if (response.data.services) {
                    const dispatchValue = { type: CheckLQ.suggestedAddress, value: [] };
                    dispatch(dispatchValue);
                    response.data.services.forEach(key => {
                        if (Service.voice.indexOf(key.servicename.toUpperCase()) >= 0) {
                            if (key.qualified !== "Y") {
                                NonFDVFlow = true;
                                var Qstring = "";
                                /* if (lqState.selectedUnit !== null && lqState.selectedUnit.unit !== undefined) {
                                    Qstring = "?isatom=Y&addressline1=" + lqState.selectedAdr.street + "&addressline2=" + lqState.selectedUnit.unit + "&city=" + lqState.selectedState.altCity + "&state=" + lqState.selectedState.state + "&zip=" + lqState.selectedState.zip + "&addressId=" + lqState.selectedUnit.addressID + "&src=frmAtom";
                                }
                                else {
                                    Qstring = "?isatom=Y&addressline1=" + lqState.selectedAdr.street + "&city=" + lqState.selectedState.altCity + "&state=" + lqState.selectedState.state + "&zip=" + lqState.selectedState.zip + "&addressId=" + lqState.selectedAdr.addressID + "&src=frmAtom";
                                } */
                                tempSCData.detailPageName = "lq address verification - Non FDV eligible";
                                tempSCData.events = "event5,event8,event88"
                                updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                                Qstring = "?isatom=Y&src=frmAtom";
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.redirectingBAU, PAGEACTIVITY.UA));
                                window.location.href = Pages.CheckAvail + Qstring;
                            }
                        }
                    }
                    );
                    if (response.data.parsedAddress && response.data.parsedAddress.length === 1) {
                        setParsedaddress(dispatch, response.data.parsedAddress[0]);
                    }
                    dispatch({ type: 'EMPTYBUILDFIOSSTATE', value: "" });
                    dispatch({ type: CartActions.clearcartstate, value: "" });
                    if (!NonFDVFlow) {
                        tempSCData.detailPageName = "lq address verification - Fios eligible";
                        tempSCData.events = "event5,event8,event88"
                        updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
                        dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data });
                        qualResponse = response;
                        api(retrieveQualdetailsUrl, 'GET', '').then(response => {
                            if (InHomeUtils.isNull(response) || response === "") {
                                errorMsg = "RetrievequalResponseNull";
                            }
                            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                                dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
                                let nsiIndicator = "";
                                if (InHomeUtils.isNotNull(response.data.addressValidationRecordAGR) && response.data.addressValidationRecordAGR.length) {
                                    nsiIndicator = response.data.addressValidationRecordAGR[0].nonStandardAddressFlag;
                                    dispatch({ type: 'NSI_INDICATOR', value: nsiIndicator });
                                    if (nsiIndicator === "Y") {
                                        let nsiUrl = apiUrl().nsiNotify
                                        api(nsiUrl, 'POST', getNsiRequest(addrID, lqState.selectedState.state)).then(response => {
                                            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                                                dispatch({ type: 'NSI_STATUS', value: response.data });
                                            }
                                            else if (InHomeUtils.isNull(response) || (InHomeUtils.isNotNull(response) && (InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400')))) {
                                                dispatch({ type: 'NSI_FAILED', value: true });
                                            }
                                        })
                                    }
                                }
                                if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                                    && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible) && response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible === "Y") {
                                    dispatch({ type: "PRESALE_ELIGIBLE", value: true })
                                    if (response.data.getAdditionalInfo !== null && response.data.getAdditionalInfo !== undefined && response.data.getAdditionalInfo.ofsEstimateDays !== "") {
                                        dispatch({ type: "PRESALE_ESTIMATEDAYS", value: response.data.getAdditionalInfo.ofsEstimateDays })
                                    }
                                }
                                if (InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                                    && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent) && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                                    logOtherInfo(detailsInfo('loopQual', visitId, 'checkAddr', "IONT Eligible", PAGEACTIVITY.UA));
                                    dispatch({ type: "IONT_ELIGIBLE", value: true })
                                    tempSCData.IONTEligible = true;
                                }
                                if (InHomeUtils.isNotNull(response.data.getAdditionalInfo) && InHomeUtils.isNotNull(response.data.getAdditionalInfo.isBOSTONDMA)) {
                                    dispatch({ type: "BOSTONDMA", value: response.data.getAdditionalInfo.isBOSTONDMA })
                                }
                                qualResponseHandling(dispatch, qualResponse, lqState, visitId, email, mtn);
                                //set bannerType on LQ success
                                setBannerType(dispatch, lqState, visitId, qualResponse.data);
                            }
                            else {
                                let errMsg = ""; let stat = "";
                                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (response.meta.code))
                                    stat = response.meta.code;
                                loaderActive({ isLoaderActive: false }, dispatch)
                                if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.message)) {
                                    errMsg = response.message;
                                    if (InHomeUtils.isNotNull(response.response) && InHomeUtils.isNotNull(response.response.status))
                                        stat = response.response.status;
                                }
                                if (errMsg !== "" || stat !== "")
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr_RetrieveQual', PAGEACTIVITY.MSG.lqError + "-" + errMsg + " - " + stat, PAGEACTIVITY.UA));
                            }
                        })
                            .catch(error => {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqError + "-" + "CatchBlock1" + " - " + error.message, PAGEACTIVITY.UA));
                                errorAction("ERROR", "RetrieveQual", error.message, "applogs", visitId, dispatch, false, "");
                                loaderActive({ isLoaderActive: false }, dispatch)
                            });
                    }
                }
                else if (response.data.addressNotFound) {
                    //dispatch({ type: "LQ_CANT_FIND_ADDRESS_CLICKED", value: true }); 
                    //redirectTo(Pages.Help, dispatch)     
                    loaderActive({ isLoaderActive: false }, dispatch)
                    logOtherInfo(detailsInfo('loopQual', visitId, 'checkAddr', "StreetNotFound"));
                    dispatch({ type: "STREET_NOT_FOUND", value: null });
                    if (lqState.isoneLQFlow) {
                        tempSCData.detailPageName = "5g out of franchise"
                        updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                    }
                    else {
                        updateSCcustomEvent("outOfFranchise", "ddCheckAvailabilityPageViewEvent", "");
                    }
                }
            }
            else if (!isLqRetry) {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqRetry, PAGEACTIVITY.UA));
                isLqRetry = true;
                checkAddr(lqState, dispatch, visitId, emailValue, mtnValue, isLqRetry);
            }
            else {
                let errMessge = "MethodName:loopQual,errorMessage:API response error";
                if (status === "" && InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code))
                    status = response.meta.code;
                if (errorMsg !== "" || status !== "")
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr_error1', PAGEACTIVITY.MSG.lqError + "-" + errorMsg + " - " + status, PAGEACTIVITY.UA));
                if (status !== '')
                    errorAction("LBO", "CheckLQ", errMessge, "applogs", visitId, dispatch, true, "GBBERR-" + status);
                else if (errorMsg !== '')
                    errorAction("LBO", "CheckLQ", errMessge, "applogs", visitId, dispatch, true, "GBBERR-ResponseNull");
                else
                    errorAction("LBO", "CheckLQ", errMessge, "applogs", visitId, dispatch, true, "GBBERR");

                loaderActive({ isLoaderActive: false }, dispatch)
            }
        })
            .catch(error => {
                if (error.message !== '')
                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'checkAddr', PAGEACTIVITY.MSG.lqError + "-" + "CatchBlock2" + " - " + error.message, PAGEACTIVITY.UA));
                if (status !== '')
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR-" + status);
                else if (errorMsg !== '')
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR-ResponseNull");
                else
                    errorAction("LBO", "CheckLQ", error.message, "applogs", visitId, dispatch, true, "GBBERR");
                loaderActive({ isLoaderActive: false }, dispatch)
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'checkAddr', ex);
    }
};

export const qualResponseHandling = (dispatch, qualResponse, lqState, visitId, email, mtn) => {
    try {
        //Adding GateKeeper for Initial Release
        if (Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(qualResponse.data.smartCartDetails) && qualResponse.data.smartCartDetails.smartCartAvailable) {
            //saveAction.processSaveCart(visitId, dispatch, lqState, email, mtn);
        }
        if (qualResponse.data.inService === "N" && qualResponse.data.pendingOrder === "N") {
            dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
        }
        if (qualResponse.data.inService === "N") {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-N", PAGEACTIVITY.UA));
            //Adding GateKeeper for Initial Release
            if (Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(qualResponse.data.smartCartDetails) && qualResponse.data.smartCartDetails.smartCartAvailable) {
                if (qualResponse.data.type === 'EmailId' || qualResponse.data.type === 'Mtn') {
                    tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide mtn or email";
                }
                else if (qualResponse.data.type === 'Mon') {
                    tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide cart number";
                }
                else {
                    tempSCData.detailPageName = "smart cart resume entry| continue your cart| no cart number";
                }
                updateSCcustomEvent("smartSave", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-Y", PAGEACTIVITY.UA));
                redirectTo(Pages.SmartSave, dispatch);
            }
            else if (qualResponse.data.pendingOrder === "Y") {
                updateSCcustomEvent("pendingOrder", "ddCheckAvailabilityPageViewEvent", "");
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.PendingOrder + "-Y", PAGEACTIVITY.UA));
                redirectTo(Pages.PendingOrder, dispatch);
            }
            else {
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.SmartCartFound + "-N", PAGEACTIVITY.UA));
                redirectTo(Pages.BuildProduct, dispatch)
            }
        }
        else {
            updateSCcustomEvent("existingSrvc", "ddCheckAvailabilityPageViewEvent", "");
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'qualResponseHandling', PAGEACTIVITY.MSG.ExistingService + "-Y", PAGEACTIVITY.UA));
        }
        loaderActive({ isLoaderActive: false }, dispatch)
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'qualResponseHandling', ex);
    }
}

export const setCantFindAddress = (value, dispatch) => {
    dispatch({ type: 'LQ_CANT_FIND_ADDRESS_CLICKED', value: value });
};

export const saveTwsCustomerDetailsEC = async(response, visitId) => {
    try {
        const { attributes } = response?.data;
        let url = apiUrl().twsSiginInDetails;
        var reqObject = attributes.reduce(
            (obj, item) => Object.assign(obj, { [item.handle]: item?.value }), {});
        let request = {
            clientId: "vzcom",
            requestTrackingNumber: visitId,
            emailId: reqObject?.email,
            twsData: {
                firstName: reqObject?.fname,
                lastName: reqObject?.lname,
                email: reqObject?.email,
                uuid: reqObject?.uuid,
                zip: reqObject?.zip,
                group: response?.status,
                status: response?.transaction,
            }
        }
        api(url, 'POST', JSON.stringify(request)).then(resp => {
            console.log(resp)
            if (resp) {
                console.log(resp, "success")
            }
            else {
                console.log("failure")
            }
        }).catch(error => {
                let errorMsg = `MethodName:saveTwsCustomerDetailsEC,errorMessage:${error.message}`;
                logKafka("ERROR", "xpsEntry", errorMsg, getErrorLogUrl, "applogs", visitId);
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'saveTwsCustomerDetailsEC', errorMsg, PAGEACTIVITY.UA));
            });
    }
    catch (ex) {
        catchJSException(PAGEACTIVITY.PAGE.LQ, visitId, 'saveTwsCustomerDetailsEC', ex);
    }
};

export const validateSignin = (dispatch, visitId) => {
    try {
        let url = apiUrl().getAccount + '/validateSignInforMoves';
        let agencyID = window.sessionStorage.getItem('agencyID')
        if(agencyID !== null && agencyID !== undefined){
            url = url + '?agency=' + agencyID;
        } 
        api(url, 'POST').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: CheckLQ.validateSignin, value: response.data.isPendingOrderAvailable });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:validateSignin,errorMessage:${error.message}`;
                logKafka("ERROR", "looQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'validateSignin', ex);
    }
};

export const resetLqResponse = (action, dispatch) => {
    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: action });
}

export const rememberMeCheck = (status, dispatch) => {
    dispatch({ type: 'LQ_ON_REMEMBERME_CHECK', value: status })
};

export const onSelectSignin = (action, dispatch) => {
    dispatch({ type: CheckLQ.signInAs, value: action });
}

export const fNameErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.fNameErr, value: status })
};

export const lNameErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.lNameErr, value: status })
};

export const emailErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.emailErr, value: status })
};

export const mtnErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.mtnErr, value: status })
};

export const mtn = (status, dispatch) => {
    dispatch({ type: FutureNotification.mtn, value: status })
};

export const ftvCheckErr = (status, dispatch) => {
    dispatch({ type: FutureNotification.ftvCheckErr, value: status })
};

export const validateInput = (action, dispatch) => {
    dispatch({ type: FutureNotification.validateInput, value: action });
}

export const ftvCheck = (status, dispatch) => {
    dispatch({ type: FutureNotification.ftvCheck, value: status })
}

export const validateSignInCoupon = (action, dispatch) => {
    dispatch({ type: CheckLQ.validateSignInCoupon, value: action });
}

export const phoneNumCheck = (status, dispatch) => {
    dispatch({ type: CheckLQ.phoneNumCheck, value: status })
}

export const mtnSignInErr = (status, dispatch) => {
    dispatch({ type: CheckLQ.mtnSignInErr, value: status })
};

export const mtnSignIn = (status, dispatch) => {
    dispatch({ type: CheckLQ.mtnSignIn, value: status })
};

const getNsiRequest = (addressId, state) => {
    let request = {
        addressId: addressId,
        programName: 'vzcom',
        inquiryType: 'status',
        nsiID: '',
        state: state,
        firstName: '',
        lastName: '',
        emailAddress: '',
        contactPhone: '',
        notifyFios: '',
        notifyFiosTv: '',
        siResponse: ''
    }
    return JSON.stringify(request);
}

export const validateVZWOfferEligibility = (dispatch, mtn, visitId, fromLQPage, addrID) => {
    try {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "Inside validateVZWOfferEligibility"));
        let url = apiUrl().vzwOfferEligibility;
        let request = {
            "mtn": mtn,
            "addressId": addrID
        };

        api(url, 'POST', JSON.stringify(request)).then(response => {
            //response= resp.samplerespdata
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { data: response.data, isVZWOfferCallComplete: true } });
                if (InHomeUtils.isNotNull(response.data) && response.data.isCCEligible === "Y") {
                    tempSCData.detailPageName = "ec| services overview| info and credit - billinfo| vzw mtn eligible";
                    logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn eligible for Online CC"));
                }
                else {
                    tempSCData.detailPageName = "ec| services overview| info and credit - billinfo| vzw mtn ineligible";
                    logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC"));
                }

                if (!fromLQPage) {
                    if (InHomeUtils.isNotNull(response.data) && response.data.isCCEligible === "Y") {
                        doCreditAssessment(dispatch, visitId);
                    }
                    dispatch({ type: MTNValidation.updateVZWOfferPageCallStatus, value: "CheckoutPage" });
                    if (response.data.updateCart) {
                        url = apiUrl().getCartAcc + '/' + visitId;
                        api(url, 'GET', "").then(resp => {
                            if (InHomeUtils.isNotNull(resp) && InHomeUtils.isNotNull(resp.meta) && InHomeUtils.getIndexOf(resp.meta.code, '200')) {
                                dispatch({
                                    type: "UPDATE_CART",
                                    value: {
                                        cartResponse: resp.data.cartTierPricing,
                                        cartHeader: getCartHeader(resp.data.cartTierPricing.tierContent, visitId),
                                        cartData: getCartData(resp.data.cartTierPricing.tierContent, visitId),
                                        cartOrderDetail: resp.data.orderDetail
                                    }
                                });
                            }
                        })
                    }
                }
                else {
                    dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { data: response.data, isVZWOfferCallComplete: true } });
                    dispatch({ type: MTNValidation.updateVZWOfferPageCallStatus, value: "LQPage" });
                }
            }
            else {
                tempSCData.detailPageName = "ec| services overview| info and credit - billinfo| vzw mtn ineligible";
                logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC - response error"));
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { isVZWOfferCallComplete: false } })
            }
            updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                dispatch({ type: MTNValidation.updateVZWOfferEligibility, value: { isVZWOfferCallComplete: false } })
                logOtherInfo(detailsInfo('loopQual', visitId, 'validateVZWOfferEligibility', "mtn ineligible for Online CC - exception"));
                let errorMsg = `MethodName:validateVZWOfferEligibility,errorMessage:${error.message}`;
                logKafka("ERROR", "MTNQual", errorMsg, getErrorLogUrl, "applogs", visitId);
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'validateVZWOfferEligibility', ex);
    }
};

export const setBanner = (dispatch, lqState, visitId) => {
    try {
        let bannerType = '';
        if (InHomeUtils.isNotNull(lqState)) {
            if(InHomeUtils.isNotNull(lqState.hoaFlowDetails) && InHomeUtils.isNotNull(lqState.hoaFlowDetails.isHoaFlow) && lqState.hoaFlowDetails.isHoaFlow) {
                bannerType = BannerTypes.VecOrder;
            }
            else if(lqState.showStadia){
                bannerType = BannerTypes.Stadia;
            }
            else if(lqState.showMarvel){
                bannerType = BannerTypes.Marvel;
            }
        }
        if (bannerType !== '') {
            updateBannerType(bannerType, dispatch);
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'setBanner', ex);
    }
}

export const setBannerType = (dispatch, lqState, visitId, qualResponse) => {
    try {      
        
        let bannerType = '';
        if (InHomeUtils.isNotNull(lqState)) {
            if(lqState.showStadia){
                bannerType = BannerTypes.Stadia;
            }
            else if(lqState.showMarvel){
                bannerType = BannerTypes.Marvel;
            }
            else {
                let lqServices = (InHomeUtils.isNotNull(qualResponse) && InHomeUtils.isNotNull(qualResponse.services)) ? qualResponse.services : [];
                let dataService = 'N';
                let videoService = 'N';
                if (lqServices.length > 0) {
                    for (let i = 0; i < lqServices.length; i++) {
                        if (InHomeUtils.isNotNull(lqServices[i])) {
                            if (lqServices[i].servicename === 'FiOSData' && lqServices[i].qualified === 'Y') {
                                dataService = 'Y'
                            } else if (lqServices[i].servicename === 'Video' && lqServices[i].qualified === 'Y') {
                                videoService = 'Y'
                            }
                        }
                    }
                }

                if (InHomeUtils.isNotNull(lqState) && InHomeUtils.isNotNull(lqState.couponFlowType)) {
                    if(lqState.couponFlowType === "Employee" || lqState.couponFlowType === "Retiree"){
                        bannerType = BannerTypes.Employee;
                    }
                    else if(lqState.couponFlowType === "Affinity"){
                        bannerType = BannerTypes.connections;
                    }                    
                }
                else if (lqServices.length > 2 && dataService === 'Y' && videoService === 'N') {
                    bannerType = BannerTypes.nonFTV;
                }
                else if (InHomeUtils.isNotNull(lqState.lqQualdetails)
                    && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult)
                    && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)) {
                    let fttpAvailabilityDetailsAGR = lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR;

                    if (InHomeUtils.isNotNull(fttpAvailabilityDetailsAGR.ontAGR) && fttpAvailabilityDetailsAGR.ontAGR.length > 0) {
                        let srvcs = fttpAvailabilityDetailsAGR.ontAGR[0].portDetailAGR;
                        for (let i = 0; i < srvcs.length; i++) {
                            if (InHomeUtils.isNotNull(srvcs[i]) && InHomeUtils.isNotNull(srvcs[i].portType) && srvcs[i].portType.indexOf('VDSL') > -1) {
                                bannerType = BannerTypes.vdsl;
                            }
                        }
                    }

                    if (bannerType !== BannerTypes.vdsl && InHomeUtils.isNotNull(lqState)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified)
                        && InHomeUtils.isNotNull(lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified)
                        && lqState.lqQualdetails.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.fiosTVQualified === "N") {
                        bannerType = BannerTypes.vdsl;
                    }
                }
            }
            if (bannerType !== '') {
                updateBannerType(bannerType, dispatch);
            }
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'setBannerType', ex);
    }
};

export const fetchBanners = (dispatch, visitId) => {
    try {
        // var response = require('./../containers/banner/OrderingBanners.json');
        if (InHomeUtils.isNotNull(OrderingBanners)) {
            dispatch({ type: 'GET_BANNERS', value: OrderingBanners });
        }
        /*
        api(apiUrl().getBanners, 'GET', '').then(response => {
            if(InHomeUtils.isNotNull(response))
            dispatch({ type: 'GET_BANNERS', value: response });
        }).catch(error => {
            let errorMsg = `MethodName:fetchBanners,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
        });*/
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'fetchBanners', ex);
    }

};


export const getVendorDetailsForRetry =  async (dispatch, visitId, lqState, referralUrl) => {
    try {
        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Inside getVendorDetails"));
        let url = apiUrl().getvendorvisitdetails;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        return  api(url,'GET','');
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getVendorDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
}

export const getVendorDetails = (dispatch, visitId, lqState) => {
    try {
        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Inside getVendorDetails"));
        let url = apiUrl().getvendorvisitdetails;
        let addressRequest = null;
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
        api(url, 'GET', '').then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: 'GET_VENDOR_DETAILS', value: response.data });
                if (InHomeUtils.isNotNull(response.data.vendordetails) && response.data.vendordetails.vendor_name !== "") {
                    if (response.data.vendordetails.vendor_name === "Target") {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Target Flow"));
                        updateTargetOrdering(true, dispatch);
                    }
                    let vendordetails = {
                        vendor_name: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) ? response.data.vendordetails.vendorSalesDetails.vendor_name : response.data.vendordetails.vendor_name,
                        vendor_url: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) ? response.data.vendordetails.vendorSalesDetails.vendorurl : response.data.vendordetails.vendor_url,
                        default_tn: InHomeUtils.isNotNull(response.data.vendordetails.vendorSalesDetails) ? response.data.vendordetails.vendorSalesDetails.default_tn : response.data.vendordetails.default_tn
                    }
                    updateVendorDetails(vendordetails, dispatch);
                }
                if (InHomeUtils.isNotNull(response.data.leadlistdetails) && InHomeUtils.isNotNull(response.data.leadlistdetails.config) && response.data.leadlistdetails.config.doid !== "") {
                    logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Updating Do Flow Details"));
                    updateDOFlowDetails(response.data.leadlistdetails.config.doid, dispatch);
                }
                if (InHomeUtils.isNotNull(response.data.addressdetails) && InHomeUtils.isNotNull(response.data.addressdetails.addressID) && response.data.addressdetails.addressID !== "") {
                    addressRequest = {
                        addressID: response.data.addressdetails.addressID,
                        baseAddID: response.data.addressdetails.addressID,
                        street: response.data.addressdetails.addressline1,
                        unit: response.data.addressdetails.addressline2,
                        city: response.data.addressdetails.city,
                        state: response.data.addressdetails.state,
                        zip: response.data.addressdetails.zip,
                    }
                    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
                    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
                    if (response.data.addressdetails.addressline2 !== "") {
                        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
                    }
                }
                if (InHomeUtils.isNotNull(response.data.vendorqualification)) {
                    dispatch({ type: 'LQ_ON_CHECK_AVAILABILITY_CLICK', value: response.data.vendorqualification });
                    let retrieveQualdetailsUrl = apiUrl().retrieveQualdetails;
                    api(retrieveQualdetailsUrl, 'GET', '').then(response => {
                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "retrieve Qual Details"));
                            dispatch({ type: 'LQ_ON_RETRIEVE_QUALDETAILS', value: response.data });
                            let nsiIndicator = "";
                            if (InHomeUtils.isNotNull(response.data.addressValidationRecordAGR) && response.data.addressValidationRecordAGR.length > 0) {
                                nsiIndicator = response.data.addressValidationRecordAGR[0].nonStandardAddressFlag;
                                dispatch({ type: 'NSI_INDICATOR', value: nsiIndicator });
                                if (nsiIndicator === "Y") {
                                    let nsiUrl = apiUrl().nsiNotify
                                    api(nsiUrl, 'POST', getNsiRequest(response.vendordetails.config.addressInfo.addressId, response.vendordetails.config.addressInfo.state)).then(response => {
                                        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "nsi response is success"));
                                            dispatch({ type: 'NSI_STATUS', value: response.data });
                                        }
                                        else if (InHomeUtils.isNull(response) || ((InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && (InHomeUtils.getIndexOf(response.meta.code, '500') || InHomeUtils.getIndexOf(response.meta.code, '400'))))) {
                                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "nsi response is failed"));
                                            dispatch({ type: 'NSI_FAILED', value: true });
                                        }
                                    })
                                }
                            }
                            if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR)
                                && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR) && response.data.getBroadbandAvailabilityResult.fttpCapabilityDetailsAGR.ofsPresaleEligible === "Y") {
                                logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "PRESALE is Eligible"));
                                dispatch({ type: "PRESALE_ELIGIBLE", value: true })
                                if (response.data.getAdditionalInfo !== null && response.data.getAdditionalInfo !== undefined && response.data.getAdditionalInfo.ofsEstimateDays !== "") {
                                    dispatch({ type: "PRESALE_ESTIMATEDAYS", value: response.data.getAdditionalInfo.ofsEstimateDays })
                                }
                            }
                            if (InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult) && InHomeUtils.isNotNull(response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR)
                                && response.data.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent === "Y") {
                                logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "IONT Eligible"));
                                dispatch({ type: "IONT_ELIGIBLE", value: true })
                                tempSCData.IONTEligible = true;
                            }
                            //set bannerType on LQ success
                            setBannerType(dispatch, lqState, visitId, response.data.vendorqualification);
                        }
                    })
                        .catch(error => {
                            errorAction("ERROR", "RetrieveQual", error.message, "applogs", visitId, dispatch, false, "");
                            loaderActive({ isLoaderActive: false }, dispatch)
                        });
                    if (InHomeUtils.isNotNull(response.data.vendorqualification.smartCartDetails) && response.data.vendorqualification.smartCartDetails.smartCartAvailable && InHomeUtils.isNotNull(addressRequest)) {
                        //saveAction.processSaveCartandRedirect(visitId, dispatch, addressRequest);
                    }
                    if (response.data.vendorqualification.inService === "N" && response.data.vendorqualification.pendingOrder === "N") {
                        dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
                    }
                    if (response.data.vendorqualification.inService === "N") {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Existing Service is not Available"));
                        //Adding GateKeeper for Initial Release
                        if (Save.smartCartFlowFlag === 'true' && InHomeUtils.isNotNull(response.data.vendorqualification.smartCartDetails) && response.data.vendorqualification.smartCartDetails.smartCartAvailable) {
                            if (response.data.vendorqualification.type === 'EmailId' || response.data.vendorqualification.type === 'Mtn') {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide mtn or email";
                            }
                            else if (response.data.vendorqualification.type === 'mon') {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| provide cart number";
                            }
                            else {
                                tempSCData.detailPageName = "smart cart resume entry| continue your cart| no cart number";
                            }
                            updateSCcustomEvent("smartSave", "ddCheckAvailabilityPageViewEvent", "detailPageName");
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Smart Save"));
                            redirectTo(Pages.SmartSave, dispatch);
                        }
                        else if (response.data.vendorqualification.pendingOrder === "Y") {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Pending Order"));
                            updateSCcustomEvent("pendingOrder", "ddCheckAvailabilityPageViewEvent", "");
                            redirectTo(Pages.PendingOrder, dispatch);
                        }
                        else {
                            logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Redirecting to Build Product"));
                            redirectTo(Pages.BuildProduct, dispatch)
                        }
                    }
                    else {
                        logOtherInfo(detailsInfo('loopQual', visitId, 'getVendorDetails', "Existing Service is Available"));
                        updateSCcustomEvent("existingSrvc", "ddCheckAvailabilityPageViewEvent", "");
                    }
                }
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
            .catch(error => {
                let errorMsg = `MethodName:getVendorDetails,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getVendorDetails', ex);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    }
};

export const getRevisitDetails = (response, dispatch, visitId, lqState, changeLoc) => {
    try {
        let addressRequest = null;
        if (lqState.isoneLQFlow) {
            addressRequest = {
                addressID: response.addressId,
                street: decodeURIComponent(response.streetAddress) + ", " + decodeURIComponent(response.city) + ", " + decodeURIComponent(response.state) + ", " + response.zip,
                unit: '',
                city: decodeURIComponent(response.city),
                state: decodeURIComponent(response.state),
                zip: response.zip,
            }
        }
        else {
            addressRequest = {
                addressID: response.addressId,
                street: decodeURIComponent(response.streetAddress),
                unit: '',
                city: decodeURIComponent(response.city),
                state: decodeURIComponent(response.state),
                zip: response.zip,
            }
        }
        dispatch({
            type: 'UPDATE_RETURNVISIT_SELECTEDSTATE',
            value: addressRequest
        });
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getRevisitDetails_Revisit', PAGEACTIVITY.MSG.revisit, PAGEACTIVITY.UA));
        dispatch({ type: CheckLQ.lqRevisit, value: "Y" });

        if (changeLoc && changeLoc === 'Y') {
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.LQ, visitId, 'getRevisitDetails_Change', PAGEACTIVITY.MSG.changeAdr, PAGEACTIVITY.UA));
            dispatch({ type: CheckLQ.updateInitLoad, value: 5000 });
        }
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'getRevisitDetails', ex);
    }
};

export const onSubmitCaptcha = (captchaReq, visitId, dispatch) => {
    try {
        let url = '/inhome/validatecaptcha';
        let request = {
            'g-recaptcha-response': captchaReq
        }
        api(url, 'POST', JSON.stringify(request)).then(response => {

            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.responseCode) && response.responseCode === 0) {
                redirectTo(Pages.CheckLQ, dispatch);
            }
        }).catch(error => {
            let errorMsg = `MethodName:onSubmitCaptcha,errorMessage:${error.message}`;
            logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
        });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'onSubmitCaptcha', ex);
    }
}

export const onValidateCaptcha = (captchaReq, props) => {

    let url = '/inhome/validatecaptcha';
    let request = {
        'g-recaptcha-response': captchaReq
    }
    api(url, 'POST', JSON.stringify(request)).then(response => {
        //console.log(response);
        if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.responseCode) && response.responseCode === 0) {
            // TODO : hide loader after successful response and enable LQBTN, with false flag in updateStateLocus            
            props.dispatch({ type: CheckLQ.captchaChanged, value: 'COMPLETED' });
            props.dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: props.lqState.selectedAdr, isdisplayUnit: false } });
            checkAddr(props.lqState, props.dispatch, props.appState.visitId, props.save.saveLqEmailInput, props.save.saveLqMtnInput); //Do auto LQ on success            
            //loaderActive({ isLoaderActive: false }, props.dispatch);
        }
        else {
            //Making captcha success for testing in SIT/Staging  
            tempSCData.detailPageName = "lq address verification - captcha failure";
            tempSCData.events = "event5,event8,event88"
            updateSCcustomEvent("addrVerification", "ddCheckAvailabilityPageViewEvent", "detailPageName,events");
            props.dispatch({ type: CheckLQ.captchaChanged, value: 'COMPLETED' });
            props.dispatch({ type: CheckLQ.onStreetAddrSelected, value: { streetAddr: props.lqState.selectedAdr, isdisplayUnit: false } });
            checkAddr(props.lqState, props.dispatch, props.appState.visitId, props.save.saveLqEmailInput, props.save.saveLqMtnInput); //Do autoLQ on success

            // loaderActive({ isLoaderActive: false }, props.dispatch); 
            /* loaderActive({ isLoaderActive: false }, props.dispatch);
            redirectTo(Pages.Oof, props.dispatch); */
        }
    }).catch(error => {
        let errorMsg = `MethodName:onSubmitCaptcha,errorMessage:${error.message}`;
        logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", props.appState.visitId);
    });
}

export const updateBannerType = (status, dispatch) => {
    dispatch({ type: CheckLQ.updateBannerType, value: status })
};

export const setVendorRequest = (cookies, props, dispatch, visitId, inputDetail, lqState, isTarget) => {
    try {
        let url = apiUrl().vendorFlow;
        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });
        api(url, 'POST', vendorRequest(inputDetail)).then(response => {
            if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
                dispatch({ type: 'VENDOR_RESPONSE', value: response.data });
                if (InHomeUtils.isNotNull(response.data) && response.data.isVendorFlowAllowed && response.data.visitid !== "" && response.data.visitorid !== "") {
                    let data = { visit_id: response.data.visitid, visitor_id: response.data.visitorid }
                    setVendorCookie(cookies, data, props);
                    if (!isTarget) {
                        getVendorDetails(dispatch, visitId, lqState);
                    }
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
                else {
                    dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                }
            }
            else {
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            }
        })
            .catch(error => {
                let errorMsg = `MethodName:setVendorRequest,errorMessage:${error.message}`;
                logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            });
    }
    catch (ex) {
        catchJSException('loopQual', visitId, 'setVendorRequest', ex);
    }
};

const vendorRequest = (inputDetail) => {
    let request = {
        leadListDetails: {
            config: {
                storeId: InHomeUtils.isNotNull(inputDetail.storeid) ? inputDetail.storeid : "",
                doid: inputDetail.doid !== "" ? inputDetail.doid : "",
                location: "",
                lob: "",
                vendorId: "",
                locationId: "",
                sessionId: "",
                repInfo: {
                    repId: InHomeUtils.isNotNull(inputDetail.repid) ? inputDetail.repid : "",
                    userId: "",
                    firstName: "",
                    lastName: "",
                    repName: "",
                }
            }
        },
        vendorQueryDetails: {
            c: InHomeUtils.isNotNull(inputDetail.cVal) ? inputDetail.cVal : "",
            cmpId: InHomeUtils.isNotNull(inputDetail.cmp) ? inputDetail.cmp : "",
            abrVal: InHomeUtils.isNotNull(inputDetail.abrVal) ? inputDetail.abrVal : ""
        }
    }
    return JSON.stringify(request);
}

export const setParsedaddress = (dispatch, parsedResponse) => {
    let addressRequest = null;
    addressRequest = {
        addressID: parsedResponse.addressID,
        street: parsedResponse.street,
        unit: parsedResponse.unit,
        city: parsedResponse.city,
        state: parsedResponse.state,
        zip: parsedResponse.zipCode,
    }
    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDSTATE', value: addressRequest });
    dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDADDRESS', value: addressRequest });
    if (parsedResponse.unit !== undefined && parsedResponse.unit !== "") {
        dispatch({ type: 'UPDATE_RETURNVISIT_SELECTEDUNIT', value: addressRequest });
    }
}

export const getECLQDetails = (dispatch, visitId, addressID, state, zip, lqState) => {
    try {
        let url = apiUrl().ecLoopQualDetails + '?state=' + state + '&addressID=' + addressID + '&zip=' + zip;

        dispatch({
            type: 'LOADER_ACTIVE',
            value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
        });

        api(url, 'GET', '').then(response => {
            if (response && response.getLoopAvailabilityResponseMsg) {
                dispatch({
                    type: 'SET_EC_LQ_Response',
                    value: response
                });
                //"V,H,M,C"
                if(InHomeUtils.isNotEmpty(response.hoaFlag) &&  "V".indexOf(response.hoaFlag) > -1){
                    dispatch({
                        type: HOAFlow.onHoaFlowCreation,
                        value: true
                    });
                    fetchHoaDefaults(dispatch,visitId);
                    lqState.hoaFlowDetails = {isHoaFlow : true};
                }
                setBanner(dispatch, lqState, visitId);
            }
            dispatch({
                type: 'LOADER_ACTIVE', value: { isLoaderActive: false }
            });
        })
            .catch(error => {
                logOtherInfo(detailsInfo('BuildProducts', visitId, 'getECLQDetails', "Exception is: " + error.message));
            });
    }
    catch (ex) {
        catchJSException('BuildProducts', visitId, 'getECLQDetails', ex);
    }
}